import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import React, { useEffect, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import moment from 'moment';
import { toast } from 'react-toastify';
import IconToast from '../../../components/NewToast';
import { fetchMePolicy, insurerInfo } from '../../../store/policy/duck';
import { deletePolicy, editPolicy } from '../../../store/policy/api';
import { fetchPolicy } from '../../../store/policy/api';
import { createDemoClient, editPortfolio } from '../../../store/client/api';
import { getEmergencyExport } from '../../../store/emergencyExport/api';
import { getPDF } from '../../../store/pdf/api';
import { trackDirect } from '../../../store/analytics/api';
import {
  TextField,
  Button,
  Typography,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  Box,
  RadioGroup,
  Radio,
  FormControlLabel,
  useMediaQuery,
  Tooltip
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import MessageSquare from 'lucide-react/dist/esm/icons/message-square';
import MessageSquarePlus from 'lucide-react/dist/esm/icons/message-square-plus';
import Trash2 from 'lucide-react/dist/esm/icons/trash-2';
import PlusCircle from 'lucide-react/dist/esm/icons/plus-circle';
import AladdinHint from '../../../components/AladdinHint/AladdinHint';
import BottomSheetOrDialog from '../../../components/BottomSheetOrDialog/BottomSheetOrDialog';
import VoiceCreateSosPaperButton from '../../../components/VoiceCreateSosPaperButton/VoiceCreateSosPaperButton';
import { SUB_CATEGORY_COLORS, SUB_CATEGORY_ID_MAPPING } from '../../../utils/policy';
import { insurerRegionFilter } from '../../../utils/region';
import { isInsurerOther, isInsurerWhatIf, getMostLikelyInsurer } from '../../../utils/insurer';
import { translateMessage } from '../../../utils/locale';
import NativeOrWeb from '../../../utils/native';
import { tracking } from '../../../utils/tracking';
import PolicyReviewChooseClient from '../../PolicyReview/PolicyReviewChooseClient/PolicyReviewChooseClient';
import { updateViewingClient } from '../../../store/client/duck';
import { setClientIdLocalStorage } from '../../../components/ClientEntry/utils';
import { isClientDisconnected } from '../../../components/ClientEntry/utils';
import ModeToggleButton from './ModeToggleButton/ModeToggleButton';
import RemarkEditorOverlay from './RemarkEditorOverlay';
import { useTheme } from '@mui/material/styles';
import '../../PolicyReview/PolicyReviewContainer.scss';
import './CreateDemoClient.scss';
import { clientPath } from '../../../utils/client-route';
import TravelKitLinkConstructor from '../../ExportOptions/TravelKitLinkConstructor/TravelKitLinkConstructor';

const CreateDemoClient = ({ intl, userDetails, history, viewingClient, updateViewingClient }) => {
  const shouldShowOnlineSosPaper = true; // available to all; was gated on FEATURE_SOS during testing
  const [sosLinkDialogOpen, setSosLinkDialogOpen] = useState(false);
  var isWideScreen = useMediaQuery(theme => theme.breakpoints.up('sm'));
  var adviser = useSelector(s => s.user.userDetails);
  var insurers = useSelector(s => s.policy.insurers);

  const [clientName, setClientName] = useState('');
  const [policies, setPolicies] = useState([]);
  const [currentPolicyIndex, setCurrentPolicyIndex] = useState(-1);
  const [currentOtherPolicyIndex, setCurrentOtherPolicyIndex] = useState(-1);
  const [selectInsurerDialogOpen, setSelectInsurerDialogOpen] = useState(false);
  const [clientCreatedDialogOpen, setClientCreatedDialogOpen] = useState(false);
  const [sendToClientDialogOpen, setSendToClientDialogOpen] = useState(false);
  const [clientNameError, setClientNameError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [remarkSaving, setRemarkSaving] = useState(false);
  const [policiesLoading, setPoliciesLoading] = useState(false);
  const [pdfLanguage, setPdfLanguage] = useState(adviser.language || 'zh-Hant-HK');
  const [newClientId, setNewClientId] = useState('');
  const [mode, setMode] = useState('create');
  const [deletePolicyDialogOpen, setDeletePolicyDialogOpen] = useState(false);
  const [policyPendingDeletion, setPolicyPendingDeletion] = useState('');
  const [source, setSource] = useState('');
  const [sourceError, setSourceError] = useState(false);
  const [remarkAnchorEl, setRemarkAnchorEl] = useState(null);
  const [remarkActiveIndex, setRemarkActiveIndex] = useState(-1);
  const clientNameRef = useRef(null);
  const otherInsurerRef = useRef(null);
  const sourceRef = useRef(null);
  var dispatch = useDispatch();
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme => theme.breakpoints.down('sm'));

  var policiesOrder = ['life', 'criticalIllness', 'medical', 'saving', 'ilas', 'accident', 'providentFund', undefined];
  var defaultPolicies = {
    life: { category: 'life', name: intl.formatMessage({ id: 'life-portfolio' }) },
    criticalIllness: { category: 'criticalIllness', name: intl.formatMessage({ id: 'ci-portfolio' }) },
    medical: { category: 'medical', name: intl.formatMessage({ id: 'med-portfolio' }) },
    saving: { category: 'saving', name: intl.formatMessage({ id: 'saving-portfolio' }) },
    ilas: { category: 'ilas', name: intl.formatMessage({ id: 'ilas-portfolio' }) },
    accident: { category: 'accident', name: intl.formatMessage({ id: 'accident-portfolio' }) },
    providentFund: { category: 'providentFund', name: intl.formatMessage({ id: 'provident-fund-portfolio' }) }
  };

  useEffect(() => {
    dispatch(fetchMePolicy());
    dispatch(insurerInfo());
  }, [dispatch]);

  useEffect(() => {
    if (insurers && mode === 'create') {
      let initialPolicies = Object.values(defaultPolicies);
      initialPolicies[0].insurer = selectRandomInsurer();
      initialPolicies[1].insurer = selectRandomInsurer();
      initialPolicies[6].insurer = selectRandomInsurer();
      setPolicies(initialPolicies);
    }
  }, [insurers, intl, mode]);

  useEffect(() => {
    if (history.location.state?.mode) {
      setMode(history.location.state.mode);
      history.replace({ ...history.location, state: { ...history.location.state, mode: undefined } });
    }
  }, [mode]);

  const fetchPolicies = async () => {
    setPoliciesLoading(true);
    let newPolicies = await fetchPolicy({ clientId: viewingClient._id });
    newPolicies.portfolio.map(newPolicy => {
      newPolicy.name = newPolicy.policyName;
      if (newPolicy.insurerId?.insurerId === 'Other') {
        newPolicy.otherInsurer = newPolicy.insurer;
      }
      newPolicy.insurer = newPolicy.insurerId;
      newPolicy.existingPolicy = true;
      newPolicy.category = SUB_CATEGORY_ID_MAPPING[newPolicy.subCategoryId];
      if (newPolicy.category === 'saving' && newPolicy.guaranteeValue === 'No') {
        newPolicy.category = 'ilas';
      }
    });
    for (let defaultPolicy in defaultPolicies) {
      if (!newPolicies.portfolio.find(newPolicy => newPolicy.category === defaultPolicy)) {
        newPolicies.portfolio.push(defaultPolicies[defaultPolicy]);
      }
    }
    newPolicies.portfolio.sort(
      (a, b) => policiesOrder.findIndex(i => i === a.category) - policiesOrder.findIndex(i => i === b.category)
    );
    console.log(newPolicies.portfolio);
    setPolicies(newPolicies.portfolio);
    setPoliciesLoading(false);
  };

  useEffect(() => {
    if (viewingClient && mode === 'edit') {
      fetchPolicies();
    }
    // Key on the client's _id, not the whole viewingClient object: saving dispatches
    // GET_CLIENT_BY_ID, whose success reducer replaces viewingClient with a fresh object
    // (same _id). Depending on the object reference would re-run fetchPolicies on every
    // save — a redundant getPortfolio round-trip that overwrites the just-edited local
    // list (the flicker). Re-fetch only when the selected client actually changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [viewingClient?._id, mode]);

  function onChangeClientName(event) {
    setClientNameError(false);
    setClientName(event.target.value);
  }

  function onChangePolicyName(event, index) {
    let newPolicies = [...policies];
    newPolicies[index].name = event.target.value;
    newPolicies[index].error = false;
    setPolicies(newPolicies);
  }

  function onChangePolicyRemark(event, index) {
    if (index < 0 || !policies[index]) {
      return;
    }

    let newPolicies = [...policies];
    newPolicies[index].remark = event.target.value;
    setPolicies(newPolicies);
  }

  function handleOpenRemarkPopover(event, index) {
    setRemarkAnchorEl(event.currentTarget);
    setRemarkActiveIndex(index);
  }

  function handleCloseRemarkPopover() {
    setRemarkAnchorEl(null);
    setRemarkActiveIndex(-1);
  }

  function onChangePolicyPlanType(index, planType) {
    if (index < 0 || !policies[index]) {
      return;
    }

    let newPolicies = [...policies];
    newPolicies[index].planType = planType;
    newPolicies[index].planTypeDirty = true;
    setPolicies(newPolicies);
  }

  function onChangeOtherInsurerName(event, index) {
    let newPolicies = [...policies];
    newPolicies[index].insurer = {
      _id: newPolicies[index].insurer._id,
      image: newPolicies[index].insurer.image,
      insurerId: 'Other',
      title: { en: event.target.value, zh: event.target.value, 'zh-Hant-HK': event.target.value }
    };
    setPolicies(newPolicies);
  }

  function finishTypingOtherInsurer() {
    let insurerTitle = policies[currentOtherPolicyIndex].insurer.title.en;
    let formattedInsurerTitle = policies[currentOtherPolicyIndex].insurer.title.en.trim();
    let currentPolicyCategory = policies[currentOtherPolicyIndex].category;

    let newPolicies = [...policies];
    if (!formattedInsurerTitle) {
      if (
        policies[currentOtherPolicyIndex + 1]?.category === currentPolicyCategory ||
        policies[currentOtherPolicyIndex - 1]?.category === currentPolicyCategory
      ) {
        newPolicies.splice(currentOtherPolicyIndex, 1);
      } else {
        newPolicies[currentOtherPolicyIndex].insurer = null;
      }
      setPolicies(newPolicies);
    } else if (formattedInsurerTitle !== insurerTitle) {
      let newPolicies = [...policies];
      newPolicies[currentOtherPolicyIndex].insurer.title = {
        en: formattedInsurerTitle,
        zh: formattedInsurerTitle,
        'zh-Hant-HK': formattedInsurerTitle
      };
      setPolicies(newPolicies);
    }
    setCurrentOtherPolicyIndex(-1);
  }

  function openSelectInsurerDialog(index) {
    setCurrentPolicyIndex(index);
    setSelectInsurerDialogOpen(true);
  }

  function selectInsurer(insurer) {
    let newPolicies = [...policies];
    let currentPolicyCategory = newPolicies[currentPolicyIndex].category;
    if (
      !insurer &&
      (policies[currentPolicyIndex + 1]?.category === currentPolicyCategory ||
        policies[currentPolicyIndex - 1]?.category === currentPolicyCategory)
    ) {
      newPolicies.splice(currentPolicyIndex, 1);
    } else if (insurer?.insurerId === 'Other') {
      setCurrentOtherPolicyIndex(currentPolicyIndex);
      if (!policies[currentPolicyIndex].insurer || policies[currentPolicyIndex].insurer.insurerId !== 'Other') {
        newPolicies[currentPolicyIndex].insurer = {
          _id: insurer._id,
          image: insurer.image,
          insurerId: 'Other',
          title: { en: '', zh: '', 'zh-Hant-HK': '' }
        };
      }
    } else {
      newPolicies[currentPolicyIndex].insurer = insurer;
    }
    setCurrentPolicyIndex(-1);
    setPolicies(newPolicies);
    setSelectInsurerDialogOpen(false);

    if (insurer?.insurerId === 'Other') {
      let timeout = setTimeout(() => {
        otherInsurerRef.current.focus();
      }, 200);
      return () => {
        clearTimeout(timeout);
      };
    }
  }

  function addPolicy(index, category) {
    let newPolicies = [...policies];
    newPolicies.splice(index + 1, 0, defaultPolicies[category]);
    newPolicies[index + 1].insurer = selectMostLikelyInsurer(category);
    setPolicies(newPolicies);
  }

  function addPoliciesByVoice(rawData) {
    try {
      let data = JSON.parse(rawData.replace('```json', '').replace('```', ''));
      if (data) {
        if (data.clientName) {
          setClientName(data.clientName);
        }
        let tempPolicies = Object.values([]);
        if (data.policies && data.policies.length > 0) {
          for (let policy of data.policies) {
            if (policy.category) {
              tempPolicies.push({ ...defaultPolicies[policy.category] });
              if (policy.name) {
                tempPolicies[tempPolicies.length - 1].name = policy.name;
              }
              if (policy.insurer) {
                tempPolicies[tempPolicies.length - 1].insurer = insurers.find(
                  insurer => insurer._id === policy.insurer
                );
              }
            }
          }
        }
        if (tempPolicies.length > 0) {
          setPolicies([...tempPolicies]);
        }
      }
    } catch (error) {
      console.log(error);
    }
  }

  function selectRandomInsurer() {
    let filteredInsurers = insurers
      .filter(insurerRegionFilter)
      .filter(insurer => !isInsurerWhatIf(insurer) && !isInsurerOther(insurer));
    let randomInsurer = filteredInsurers[Math.floor(Math.random() * filteredInsurers.length)];
    return randomInsurer;
  }

  function selectMostLikelyInsurer(category) {
    let otherCategoriesInsurers = [];
    let sameCategoryInsurers = [];
    for (let policy of policies) {
      if (policy.insurer && policy.insurer.insurerId !== 'Other') {
        if (policy.category === category) {
          sameCategoryInsurers.push(policy.insurer);
        } else {
          otherCategoriesInsurers.push(policy.insurer);
        }
      }
    }
    otherCategoriesInsurers = otherCategoriesInsurers.filter(
      otherCategoriesInsurer => !sameCategoryInsurers.includes(otherCategoriesInsurer)
    );

    if (otherCategoriesInsurers.length > 0) {
      var randomInsurer = otherCategoriesInsurers[Math.floor(Math.random() * otherCategoriesInsurers.length)];
    } else {
      var randomInsurer = selectRandomInsurer();
    }
    return randomInsurer;
  }

  function reArrangeInsurers(insurers, company) {
    let filteredInsurers = insurers.filter(insurerRegionFilter).filter(insurer => !isInsurerWhatIf(insurer));
    let result = ['disabled', ...filteredInsurers];
    let other = result.find(insurer => isInsurerOther(insurer));
    if (other) {
      result.splice(result.indexOf(other), 1);
      result.push(other);
    }

    let mostLikelyInsurer = getMostLikelyInsurer(insurers, company);
    if (mostLikelyInsurer) {
      result.splice(result.indexOf(mostLikelyInsurer), 1);
      result.unshift(mostLikelyInsurer);
    }

    return result;
  }

  async function createClientAndPolicies() {
    let error = false;
    let newPolicies = [];
    let newPoliciesWithErrors = [...policies];

    for (let index = 0; index < policies.length; index++) {
      if (policies[index].insurer?.title.en) {
        if (!policies[index].name) {
          error = true;
          newPoliciesWithErrors[index].error = true;
        } else {
          newPolicies.push(policies[index]);
          newPoliciesWithErrors[index].error = false;
        }
      }
    }
    setPolicies(newPoliciesWithErrors);

    if (!clientName) {
      error = true;
      setClientNameError(true);

      let timeout = setTimeout(() => {
        clientNameRef.current.focus();
      }, 200);

      return () => {
        clearTimeout(timeout);
      };
    } else {
      setClientNameError(false);
    }

    if (!source) {
      error = true;
      setSourceError(true);

      let timeout = setTimeout(() => {
        sourceRef.current.focus();
      }, 200);

      return () => {
        clearTimeout(timeout);
      };
    } else {
      setSourceError(false);
    }

    if (!error) {
      tracking('Click on Create Demo Client Sample - Add Demo');
      setLoading(true);
      let result = await createDemoClient({ clientName, source, policies: newPolicies });
      setLoading(false);
      if (result.success) {
        setNewClientId(result.data);
        setClientCreatedDialogOpen(true);
        dispatch({
          type: 'GET_CLIENT_BY_ID',
          payload: { clientId: result.data }
        });
      }
    }
  }

  async function createAndUpdatePolicies() {
    let error = false;
    let newPolicies = [];
    let newPoliciesWithErrors = [...policies];

    for (let index = 0; index < policies.length; index++) {
      if (policies[index].insurer?.title.en) {
        if (!policies[index].name) {
          error = true;
          newPoliciesWithErrors[index].error = true;
        } else {
          newPolicies.push(policies[index]);
          newPoliciesWithErrors[index].error = false;
        }
      }
    }
    setPolicies(newPoliciesWithErrors);

    if (!error) {
      setLoading(true);
      let result = await editPortfolio({ clientId: viewingClient._id, policies: newPolicies });
      setLoading(false);
      if (result.success) {
        setNewClientId(viewingClient._id);
        setClientCreatedDialogOpen(true);
        dispatch({
          type: 'GET_CLIENT_BY_ID',
          payload: { clientId: viewingClient._id }
        });
      }
    }
  }

  async function generate() {
    setLoading(true);
    let POLICY_INFO_TYPE = {
      POLICY_NO: 0,
      POLICY_NAME: 1
    };
    let result = await getEmergencyExport(newClientId);
    let options = {
      language: pdfLanguage,
      data: {
        ...result.emergencyExport,
        adviserId: adviser._id,
        clientId: newClientId
      },
      selectName: true,
      selectPolicyInfo: true,
      selectPolicyInfoType: POLICY_INFO_TYPE.POLICY_NAME,
      selectPersonalPolicy: true,
      selectWorkplacePolicy: true,
      selectGeneralPolicy: true,
      selectPolicyRemark: true,
      selectMacauInfo: false,
      useTeamLogo: true,
      changeHeaderImage: false,
      showReferIcon: true,
      remark: translateMessage('export_default_remark_with_style', pdfLanguage),
      outputFormat: 'pdf',
      referById: newClientId
    };

    let pdfBlob = await getPDF('export', options);
    trackDirect('exportEmergencyReference', 'demo');
    const exportClientName = result.emergencyExport?.clientName || clientName;
    await NativeOrWeb.downloadFile(
      pdfBlob,
      `Summary_${(exportClientName || 'Client').split(' ')[0]}_${moment().format('DDMMMYYYY')}.pdf`,
      'application/pdf'
    );
    setLoading(false);
    setClientCreatedDialogOpen(false);
    setSendToClientDialogOpen(true);
  }

  function goToClientPage() {
    localStorage.setItem('clientId', JSON.stringify(newClientId));
    history.replace(clientPath());
  }

  function goToClientEmergencyReference() {
    localStorage.setItem('clientId', JSON.stringify(newClientId));
    history.replace({ pathname: '/emergency_reference', exportClientId: newClientId });
  }

  function exportPdf() {
    tracking('Click on Export Demo Client PDF - Add Demo');
    generate();
  }

  const selectClient = client => {
    const isDisconnected = isClientDisconnected(viewingClient);
    if (isDisconnected) {
      toast.info(
        IconToast(
          'error',
          intl.formatMessage({ id: 'unable-to-edit-sos-paper-for-client' }, { name: viewingClient.name })
        ),
        { className: 'new-toast' }
      );
    } else {
      updateViewingClient(client);
      setClientIdLocalStorage(client._id);
    }
  };

  const onSelectClient = client => {
    selectClient(client);
  };

  function openDeletePolicyDialog(policy, index) {
    if (policy.existingPolicy) {
      setPolicyPendingDeletion(policy._id);
      setDeletePolicyDialogOpen(true);
    } else {
      let newPolicies = [...policies];
      newPolicies.splice(index, 1);
      for (let defaultPolicy in defaultPolicies) {
        if (!newPolicies.find(newPolicy => newPolicy.category === defaultPolicy)) {
          newPolicies.push(defaultPolicies[defaultPolicy]);
        }
      }
      newPolicies.sort(
        (a, b) => policiesOrder.findIndex(i => i === a.category) - policiesOrder.findIndex(i => i === b.category)
      );
      setPolicies(newPolicies);
    }
  }

  async function confirmDeletePolicy() {
    await deletePolicy(policyPendingDeletion);
    setDeletePolicyDialogOpen(false);
    let newPolicies = [...policies];
    newPolicies = newPolicies.filter(newPolicy => newPolicy._id !== policyPendingDeletion);
    for (let defaultPolicy in defaultPolicies) {
      if (!newPolicies.find(newPolicy => newPolicy.category === defaultPolicy)) {
        newPolicies.push(defaultPolicies[defaultPolicy]);
      }
    }
    newPolicies.sort(
      (a, b) => policiesOrder.findIndex(i => i === a.category) - policiesOrder.findIndex(i => i === b.category)
    );
    setPolicies(newPolicies);
  }

  return (
    <>
      {shouldShowOnlineSosPaper && (
        <TravelKitLinkConstructor
          open={sosLinkDialogOpen}
          onClose={() => setSosLinkDialogOpen(false)}
          client={mode === 'edit' ? viewingClient : null}
          adviser={userDetails}
        />
      )}
      <BottomSheetOrDialog
        open={selectInsurerDialogOpen}
        onClose={() => setSelectInsurerDialogOpen(false)}
        header={intl.formatMessage({ id: 'Select-insurer' })}
        content={
          <ul className="card-list-insurance insure">
            {reArrangeInsurers(insurers, userDetails.company).map((insurer, index) =>
              insurer === 'disabled' ? (
                <li
                  key={index}
                  className={policies[currentPolicyIndex]?.insurer ? '' : 'ins-info-selected'}
                  onClick={() => selectInsurer(null)}
                >
                  <Button variant="contained" disabled>
                    {intl.formatMessage({ id: 'demo-disabled' })}
                  </Button>
                </li>
              ) : (
                <li
                  key={index}
                  className={insurer._id === policies[currentPolicyIndex]?.insurer?._id ? 'ins-info-selected' : ''}
                  onClick={() => selectInsurer(insurer)}
                >
                  <img className="image1" src={insurer.image} alt="" />
                  <h4>{insurer.title[intl.locale]}</h4>
                </li>
              )
            )}
          </ul>
        }
        actions={[]}
        BottomSheetProps={{
          expandOnContentDrag: false,
          disableAutoDismiss: true
        }}
        DialogProps={{
          maxWidth: 'md',
          fullWidth: true
        }}
      />
      <Dialog open={clientCreatedDialogOpen}>
        <DialogTitle>
          {intl.formatMessage({
            id: mode === 'create' ? 'client-created-dialog-title' : 'policies-updated-dialog-title'
          })}
        </DialogTitle>
        <DialogContent>
          <Typography>
            {intl.formatMessage(
              { id: mode === 'create' ? 'client-created-dialog-content' : 'policies-updated-dialog-content' },
              { name: clientName }
            )}
          </Typography>
          <br />

          <div
            style={{
              display: 'flex',
              flexDirection: isWideScreen ? 'row' : 'column',
              alignItems: 'center',
              justifyItems: 'center'
            }}
          >
            <Typography style={{ marginRight: isWideScreen && 5, fontWeight: 'bold' }}>
              {intl.formatMessage({ id: 'pdf-language' })}
            </Typography>
            <RadioGroup
              row={true}
              aria-label="pdfLanguage"
              name="pdfLanguage"
              value={pdfLanguage}
              onChange={event => setPdfLanguage(event.target.value)}
            >
              <FormControlLabel
                value="en"
                control={<Radio color="primary" />}
                label={intl.formatMessage({ id: 'standard-english' })}
                style={{ margin: 0 }}
              />
              <FormControlLabel
                value="zh-Hant-HK"
                control={<Radio color="primary" />}
                label={intl.formatMessage({ id: 'traditional-chinese' })}
                style={{ margin: 0 }}
              />
              <FormControlLabel
                value="zh"
                control={<Radio color="primary" />}
                label={intl.formatMessage({ id: 'simplified-chinese' })}
                style={{ margin: 0 }}
              />
            </RadioGroup>
          </div>
        </DialogContent>
        <DialogActions>
          <Grid
            container
            style={{ width: '100%' }}
            sx={{
              justifyContent: 'space-between',
              alignItems: 'center'
            }}
          >
            <Grid>
              {!loading && (
                <Button color="primary" onClick={goToClientEmergencyReference}>
                  {intl.formatMessage({ id: 'view-pdf' })}
                </Button>
              )}
            </Grid>
            <Grid>
              <Button color="primary" variant="contained" disabled={loading} onClick={exportPdf}>
                {loading ? <CircularProgress size={24} /> : intl.formatMessage({ id: 'export-pdf' })}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
      <Dialog open={sendToClientDialogOpen}>
        <DialogTitle>{intl.formatMessage({ id: 'send-to-client-dialog-title' })}</DialogTitle>
        <DialogContent>{intl.formatMessage({ id: 'send-to-client-dialog-content' })}</DialogContent>
        <DialogActions>
          <Button color="primary" onClick={goToClientPage}>
            {' '}
            {intl.formatMessage({ id: 'OK' })}{' '}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={deletePolicyDialogOpen}>
        <DialogTitle>{intl.formatMessage({ id: 'delete-policy-dialog-title' })}</DialogTitle>
        <DialogContent>{intl.formatMessage({ id: 'delete-policy-dialog-content' })}</DialogContent>
        <DialogActions>
          <Button
            color="primary"
            onClick={() => {
              setPolicyPendingDeletion('');
              setDeletePolicyDialogOpen(false);
            }}
          >
            {' '}
            {intl.formatMessage({ id: 'Cancel' })}{' '}
          </Button>
          <Button color="primary" onClick={confirmDeletePolicy}>
            {' '}
            {intl.formatMessage({ id: 'Confirm' })}{' '}
          </Button>
        </DialogActions>
      </Dialog>
      <div
        className="policy-review-container create-demo-client-container"
        style={{ maxWidth: 800, margin: 'auto', marginBottom: 20 }}
      >
        <ModeToggleButton mode={mode} setMode={setMode} disabled={policiesLoading || remarkSaving} />

        {shouldShowOnlineSosPaper && (
          <Button
            variant="outlined"
            fullWidth
            onClick={() => {
              tracking('TravelKit Link Constructor Accessed - Add Demo');
              setSosLinkDialogOpen(true);
            }}
            style={{
              justifyContent: 'flex-start',
              textAlign: 'left',
              textTransform: 'none',
              borderColor: '#059669',
              color: '#065f46',
              borderRadius: 12,
              padding: '10px 14px',
              marginBottom: 16
            }}
          >
            <span style={{ fontSize: 22, marginRight: 10 }}>✈️</span>
            <span style={{ flex: 1 }}>
              <Typography component="span" style={{ display: 'block', fontWeight: 700, fontSize: 15 }}>
                {intl.formatMessage({ id: 'door-opener-travel-kit-title' })}
              </Typography>
              <Typography component="span" style={{ display: 'block', fontSize: 13, color: '#047857' }}>
                {intl.formatMessage({ id: 'door-opener-travel-kit-desc' })}
              </Typography>
            </span>
            <span style={{ fontSize: 20, marginLeft: 8 }}>›</span>
          </Button>
        )}

        <AladdinHint
          stepIndex={1}
          title={intl.formatMessage({ id: 'cd-client-name' })}
          hint={intl.formatMessage({ id: `cd-client-name-hint${mode === 'edit' ? '-1' : ''}` })}
          titleTypoProps={{ style: { fontSize: '125%' } }}
        />

        {mode === 'edit' ? (
          <PolicyReviewChooseClient selectedClient={viewingClient} setSelectedClient={onSelectClient} />
        ) : (
          <TextField
            label={intl.formatMessage({ id: 'client-name' })}
            inputRef={clientNameRef}
            variant="outlined"
            value={clientName}
            onChange={event => onChangeClientName(event)}
            error={clientNameError}
            helperText={clientNameError && intl.formatMessage({ id: 'Name is required' })}
            required
            style={{ marginBottom: '20px', width: '50%' }}
            slotProps={{
              input: { style: { fontSize: 16 } },
              formHelperText: { style: { fontSize: 14 } }
            }}
          />
        )}

        {mode === 'create' && (
          <Box
            ref={sourceRef}
            tabIndex={-1}
            sx={{
              display: 'flex',
              alignItems: 'center'
            }}
          >
            <Box
              style={{
                display: 'flex',
                alignItems: 'center',
                border: sourceError && '3px solid',
                borderColor: sourceError && theme.palette.error.main,
                padding: 5
              }}
            >
              <Typography style={{ marginRight: 4 }}>{intl.formatMessage({ id: 'client-type' })} *</Typography>

              <Button
                variant={source === 'Warm' ? 'contained' : 'outlined'}
                className={
                  source === 'Warm'
                    ? 'plan-type-select-button selected source-button-responsive'
                    : 'plan-type-select-button source-button-responsive'
                }
                onClick={() => {
                  setSource('Warm');
                  setSourceError(false);
                }}
              >
                {intl.formatMessage({ id: 'Warm' })}
              </Button>

              <Button
                variant={source === 'Refer' ? 'contained' : 'outlined'}
                className={
                  source === 'Refer'
                    ? 'plan-type-select-button selected source-button-responsive'
                    : 'plan-type-select-button source-button-responsive'
                }
                onClick={() => {
                  setSource('Refer');
                  setSourceError(false);
                }}
              >
                {intl.formatMessage({ id: 'Refer' })}
              </Button>

              <Button
                variant={source === 'Cold' ? 'contained' : 'outlined'}
                className={
                  source === 'Cold'
                    ? 'plan-type-select-button selected source-button-responsive'
                    : 'plan-type-select-button source-button-responsive'
                }
                onClick={() => {
                  setSource('Cold');
                  setSourceError(false);
                }}
              >
                {intl.formatMessage({ id: 'Cold' })}
              </Button>
            </Box>

            {sourceError && (
              <Typography style={{ marginLeft: 4, color: theme.palette.error.main, fontSize: 14 }}>
                {intl.formatMessage({ id: 'type-is-required' })}
              </Typography>
            )}
          </Box>
        )}

        <AladdinHint
          stepIndex={2}
          title={intl.formatMessage({ id: `cd-choose-insurer${mode === 'edit' ? '-1' : ''}` })}
          hint={intl.formatMessage({ id: `cd-choose-insurer-hint${mode === 'edit' ? '-1' : ''}` })}
          titleTypoProps={{ style: { fontSize: '125%' } }}
        />

        {policiesLoading ? (
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center'
            }}
          >
            <CircularProgress size={36} />
          </Box>
        ) : mode === 'edit' && !viewingClient ? (
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center'
            }}
          >
            <Typography style={{ fontSize: 18 }}>
              {intl.formatMessage({ id: 'please-select-a-client-first' })}
            </Typography>
          </Box>
        ) : (
          <TableContainer
            className="policy-category-table info create-demo-policy-table"
            style={{
              marginLeft: isSmallScreen ? -16 : 0,
              marginRight: isSmallScreen ? -16 : 0,
              width: isSmallScreen && '100vw'
            }}
          >
            <Table size="small">
              <TableHead>
                <TableRow className="sub-header">
                  <TableCell style={{ fontSize: 14, width: '20%', textAlign: 'center' }}>
                    {intl.formatMessage({ id: 'Type' })}
                  </TableCell>
                  <TableCell style={{ fontSize: 14, width: '40%', textAlign: 'center' }}>
                    {intl.formatMessage({ id: 'Insurer' })}
                  </TableCell>
                  <TableCell style={{ fontSize: 14, width: '30%', textAlign: 'center' }}>
                    {intl.formatMessage({ id: 'pf-plan-name' })}
                  </TableCell>
                  <TableCell style={{ width: '10%' }}>&nbsp;</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {policies.map((policy, index) => (
                  <TableRow key={index}>
                    <TableCell
                      style={{
                        fontSize: 15,
                        textAlign: 'center',
                        borderRight: `3px solid ${SUB_CATEGORY_COLORS[policy.category || 'travel']}`,
                        borderBottom:
                          policies[index + 1]?.category !== policy.category || !policy.category ? '' : 'none',
                        color: SUB_CATEGORY_COLORS[policy.category || 'travel']
                      }}
                    >
                      {policies[index - 1]?.category !== policy.category &&
                        intl.formatMessage({ id: policy.category || 'Other' })}
                    </TableCell>
                    <TableCell style={{ fontSize: 14, textAlign: 'center' }}>
                      {policy.insurer ? (
                        <>
                          {policy.insurer.insurerId === 'Other' && index === currentOtherPolicyIndex ? (
                            <TextField
                              inputRef={otherInsurerRef}
                              variant="outlined"
                              size="small"
                              value={policy.insurer.title[intl.locale]}
                              slotProps={{ htmlInput: { style: { textAlign: 'center' } } }}
                              onChange={event => onChangeOtherInsurerName(event, index)}
                              onBlur={finishTypingOtherInsurer}
                              style={{ maxWidth: isWideScreen ? 150 : '90%' }}
                            />
                          ) : (
                            <Typography style={{ whiteSpace: 'nowrap' }}>
                              {policy.otherInsurer || policy.insurer.title[intl.locale]}&nbsp;
                              {!policy.existingPolicy && (
                                <IconButton onClick={() => openSelectInsurerDialog(index)} size="large">
                                  <EditIcon color="primary" style={{ fontSize: 16 }} />
                                </IconButton>
                              )}
                            </Typography>
                          )}
                        </>
                      ) : (
                        <IconButton onClick={() => openSelectInsurerDialog(index)} size="large">
                          <EditIcon color="primary" style={{ fontSize: 16, marginRight: 0 }} />
                        </IconButton>
                      )}
                    </TableCell>
                    <TableCell style={{ fontSize: 14, textAlign: 'center' }}>
                      {policy.insurer?.title.en.trim() ? (
                        <div
                          style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: isWideScreen ? '90%' : '100%'
                          }}
                        >
                          <TextField
                            variant="standard"
                            size="small"
                            value={policy.name}
                            disabled={!policy.insurer}
                            slotProps={{
                              htmlInput: { style: { textAlign: 'center', marginBottom: 3 } },
                              formHelperText: { style: { fontSize: 12 } }
                            }}
                            onChange={event => onChangePolicyName(event, index)}
                            error={policy.error}
                            helperText={policy.error && intl.formatMessage({ id: 'Name is required' })}
                            style={{ flex: 1, marginTop: policy.error ? 14 : 0 }}
                          />
                        </div>
                      ) : (
                        <Typography style={{ color: 'grey' }}>
                          <i>{intl.formatMessage({ id: 'demo-disabled' })}</i>
                        </Typography>
                      )}
                    </TableCell>
                    <TableCell>
                      <Box
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          gap: 6,
                          flexDirection: isSmallScreen ? 'column' : 'row',
                          marginLeft: isSmallScreen && 6
                        }}
                      >
                        {policy.insurer?.title.en.trim() && (
                          <Tooltip title={intl.formatMessage({ id: policy.remark ? 'remark' : 'remark-optional' })}>
                            <IconButton
                              size="small"
                              disabled={!policy.insurer}
                              onClick={event => handleOpenRemarkPopover(event, index)}
                              style={{
                                color: policy.planType === 'Rider' || policy.remark ? '#3eda7d' : '#bdbdbd',
                                padding: 0
                              }}
                            >
                              {policy.planType === 'Rider' ? (
                                <MessageSquarePlus size={18} />
                              ) : (
                                <MessageSquare size={18} />
                              )}
                            </IconButton>
                          </Tooltip>
                        )}
                        {policy.insurer && (
                          <IconButton
                            onClick={() => {
                              openDeletePolicyDialog(policy, index);
                            }}
                            style={{ padding: 0, color: '#bdbdbd' }}
                            size="large"
                          >
                            <Trash2 size={16} />
                          </IconButton>
                        )}
                        {policy.insurer?.title.en &&
                          policies[index + 1]?.category !== policy.category &&
                          policy.category && (
                            <IconButton
                              onClick={() => addPolicy(index, policy.category)}
                              style={{ padding: 0, color: theme.palette.primary.main }}
                              size="large"
                            >
                              <PlusCircle size={24} fill="currentColor" stroke="white" strokeWidth={2} />
                            </IconButton>
                          )}
                      </Box>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}
        >
          <AladdinHint
            stepIndex={3}
            title={intl.formatMessage({ id: 'cd-make-appointments' })}
            hint={intl.formatMessage({ id: 'cd-make-appointments-hint' })}
            titleTypoProps={{ style: { fontSize: '125%' } }}
          />
          {mode === 'create' && <VoiceCreateSosPaperButton addPoliciesByVoice={addPoliciesByVoice} />}
        </Box>

        <Button
          variant="contained"
          color="primary"
          onClick={mode === 'edit' ? createAndUpdatePolicies : createClientAndPolicies}
          disabled={loading || remarkSaving || (mode === 'edit' && !viewingClient)}
          fullWidth
          style={{ marginBottom: 25 }}
        >
          {loading ? <CircularProgress size={24} /> : intl.formatMessage({ id: 'create-demo-cta' })}
        </Button>
      </div>
      <RemarkEditorOverlay
        open={Boolean(remarkAnchorEl)}
        anchorEl={remarkAnchorEl}
        onClose={() => {
          if (!remarkSaving) handleCloseRemarkPopover();
        }}
        mobile={isSmallScreen}
        title={intl.formatMessage({ id: 'remark' })}
        actions={
          <Button
            size="small"
            variant="contained"
            color="primary"
            disabled={remarkSaving}
            onClick={async () => {
              if (remarkSaving || remarkActiveIndex < 0 || !policies[remarkActiveIndex]) return;
              const policy = policies[remarkActiveIndex];
              if (mode === 'edit' && policy.existingPolicy) {
                if (!policy._id) return;
                setRemarkSaving(true);
                try {
                  const result = await editPolicy({
                    id: policy._id,
                    remark: policy.remark || '',
                    ...(policy.planTypeDirty && ['Basic', 'Rider'].includes(policy.planType)
                      ? { planType: policy.planType }
                      : {})
                  });
                  if (result?.success === true) {
                    handleCloseRemarkPopover();
                  } else {
                    toast.info(IconToast('error', intl.formatMessage({ id: 'error-msg' })), {
                      className: 'new-toast'
                    });
                  }
                } catch {
                  toast.info(IconToast('error', intl.formatMessage({ id: 'error-msg' })), { className: 'new-toast' });
                } finally {
                  setRemarkSaving(false);
                }
              } else {
                handleCloseRemarkPopover();
              }
            }}
          >
            {remarkSaving ? <CircularProgress size={20} /> : intl.formatMessage({ id: 'Confirm' })}
          </Button>
        }
      >
        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
          {remarkActiveIndex !== -1 &&
            policies[remarkActiveIndex] &&
            policies[remarkActiveIndex].category &&
            policies[remarkActiveIndex].category !== 'providentFund' && (
              <>
                <Typography style={{ fontWeight: 'bold', fontSize: '14px', color: '#374151' }}>
                  {intl.formatMessage({ id: 'Plan Type' })}
                </Typography>
                <Box style={{ display: 'flex', alignItems: 'center' }}>
                  {['Basic', 'Rider'].map(planType => {
                    const selected = (policies[remarkActiveIndex].planType || 'Basic') === planType;
                    return (
                      <Button
                        key={planType}
                        variant={selected ? 'contained' : 'outlined'}
                        className={
                          selected
                            ? 'plan-type-select-button selected source-button-responsive'
                            : 'plan-type-select-button source-button-responsive'
                        }
                        disabled={remarkSaving}
                        onClick={() => onChangePolicyPlanType(remarkActiveIndex, planType)}
                      >
                        {intl.formatMessage({ id: planType })}
                      </Button>
                    );
                  })}
                  {policies[remarkActiveIndex].planType === 'Rider' && (
                    <img src="img/rider_small.png" alt="rider" width={18} height={18} style={{ marginLeft: 8 }} />
                  )}
                </Box>
              </>
            )}
          <Typography style={{ fontWeight: 'bold', fontSize: '14px', color: '#374151' }}>
            {intl.formatMessage({ id: 'remark' })}
          </Typography>
          <TextField
            variant="outlined"
            size="small"
            multiline
            rows={3}
            autoFocus={!isSmallScreen}
            disabled={remarkSaving}
            value={
              remarkActiveIndex !== -1 && policies[remarkActiveIndex] ? policies[remarkActiveIndex].remark || '' : ''
            }
            placeholder={intl.formatMessage({ id: 'remark-optional' })}
            onChange={event => onChangePolicyRemark(event, remarkActiveIndex)}
            slotProps={{
              htmlInput: { style: { fontSize: isSmallScreen ? '16px' : '13px', lineHeight: '1.4' } }
            }}
          />
        </div>
      </RemarkEditorOverlay>
    </>
  );
};

const container = connect(
  state => ({
    userDetails: state.user.userDetails,
    viewingClient: state.client.viewingClient,
    teamCampaignCodes: state.functions.campaignCodes
  }),
  {
    updateViewingClient
  }
)(CreateDemoClient);

export default injectIntl(withRouter(container));
